export default __webpack_public_path__ + "static/12_29-baff62fe84650128bbb9e54e13d9034a.png";